import React, { useEffect } from "react";
import { Box } from "@mui/material";

// Importa el componente que acabamos de crear
import ContactoInfo from "../components/Contacto/ContactoInfo";
import ContactoForm from "../components/Contacto/ContactoForm";

export default function ContactoPage() {
  useEffect(() => {
    // Scroll arriba automático al navegar a esta ruta
    window.scrollTo(0, 0);
    document.title = "Contacto | Eléctrica GRM";
  }, []);

  return (
    <Box>
      <ContactoInfo />
      <ContactoForm />
    </Box>
  );
}
